export interface Category {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { slug: "movie", name: "电影", icon: "ri-movie-2-line", count: 1280 },
  { slug: "tv", name: "电视剧", icon: "ri-tv-2-line", count: 960 },
  { slug: "variety", name: "综艺", icon: "ri-live-line", count: 450 },
  { slug: "anime", name: "动漫", icon: "ri-emotion-happy-line", count: 820 },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};